export default __webpack_public_path__ + "475a6a1af6169f21c7ebfee564e246c1.svg";